import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { HR, Text } from '../Typography';

interface SectionConditionalProps {
  condition: 'or' | 'and';
  width?: number;
}

const Layout = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;

  p {
    color: ${theme.color.neutral[400]};
    margin: ${toRem(theme.space.sm)} ${toRem(theme.space.lg)};
    text-transform: uppercase;
    font-weight: ${theme.font.weight.semiBold};
  }
`;

const SectionConditional = ({ condition, width }: SectionConditionalProps) => (
  <Layout>
    <HR width={width} />
    <Text fontWeight="semibold"> {condition} </Text>
    <HR width={width} />
  </Layout>
);

export default SectionConditional;
